import React from "react";
import classes from "./ProjectGroupCard.scss";
import ButtonCard from "../../../ButtonCard";
import classNames from "classnames";

const ProjectGroupCardV2 = props => {
  const {
    isGlobalHeaderPresent,
    label,
    onCardClick,
    icon,
    iconStyle,
    showCardsAsColumnFlexed = false,
    testId,
  } = props;

  const containerClass = classNames({
    [classes.container]: true,
    [classes.increasedHeight]: showCardsAsColumnFlexed,
  });
  return (
    <ButtonCard
      isGlobalHeaderPresent={isGlobalHeaderPresent}
      className={containerClass}
      onClick={onCardClick}
      label={label}
      icon={icon}
      iconStyle={iconStyle}
      data-test-id={testId}
    />
  );
};

export default ProjectGroupCardV2;
